import { render } from "./AdditionalQuestionsInfoStepComponent.vue?vue&type=template&id=66f3f04f&ts=true"
import script from "./AdditionalQuestionsInfoStepComponent.ts?vue&type=script&lang=ts"
export * from "./AdditionalQuestionsInfoStepComponent.ts?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__